// [DEPRECATED_GRAPHQL] - Para eliminación: ContactPage en Conversations usa contactStore.getContacts que usa GraphQL query getData
// TODO: Eliminar después de verificar que nuevas APIs funcionan correctamente

/*
import React from "react";

import { useStore } from "../../../../../hooks";
import ContactTable from "./ContactTable/ContactTable";

const ContactPage = () => {
  const { contactStore } = useStore();

  return (
    <>
      <ContactTable contactStore={contactStore} />
    </>
  );
};

export default ContactPage;
*/

// Placeholder para evitar errores de importación
const ContactPage = () => null;
export default ContactPage;
